import { useState } from "react";
import type {
  PdfKind,
  SourceInputMode
} from "../../../../packages/import-contracts/src/index";
import { api } from "../api";

const INPUT_MODES: SourceInputMode[] = ["admin_upload_pdf", "official_url_pdf", "official_html_page"];
const PDF_KINDS: PdfKind[] = ["digital_pdf", "scanned_pdf", "mixed_pdf", "answer_key_pdf"];

export function ImportScreen() {
  const [examTypeSlug, setExamTypeSlug] = useState("");
  const [institution, setInstitution] = useState("");
  const [year, setYear] = useState("");
  const [inputMode, setInputMode] = useState<SourceInputMode>("admin_upload_pdf");
  const [pdfKind, setPdfKind] = useState<PdfKind>("digital_pdf");
  const [file, setFile] = useState<File | null>(null);

  const [docId, setDocId] = useState<string | null>(null);
  const [jobId, setJobId] = useState<string | null>(null);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function run() {
    setError(null);
    setBusy(true);
    try {
      const created = await api.createSourceDocument({
        examTypeSlug,
        institution,
        inputMode,
        pdfKind,
        year: year ? Number(year) : undefined
      });
      const id = created.sourceDocument.id;
      setDocId(id);

      if (inputMode === "admin_upload_pdf") {
        if (!file) throw new Error("PDF dosyası seçin");
        await api.uploadFile(id, file);
      }

      const job = await api.createImportJob(id);
      setJobId(job.importJob.id);
      setStatus(job.importJob.status);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  async function refresh() {
    if (!jobId) return;
    try {
      const job = await api.getImportJob(jobId);
      setStatus(`${job.importJob.status} (${job.candidateCount} candidate)`);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  return (
    <div className="panel">
      <h2>Kaynak doküman & import</h2>

      <label>Exam type slug</label>
      <input value={examTypeSlug} onChange={(e) => setExamTypeSlug(e.target.value)} placeholder="tyt-2023" />

      <label>Kurum</label>
      <input value={institution} onChange={(e) => setInstitution(e.target.value)} placeholder="OSYM" />

      <label>Yıl</label>
      <input value={year} onChange={(e) => setYear(e.target.value)} placeholder="2023" inputMode="numeric" />

      <label>Giriş tipi</label>
      <select value={inputMode} onChange={(e) => setInputMode(e.target.value as SourceInputMode)}>
        {INPUT_MODES.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>

      <label>PDF türü</label>
      <select value={pdfKind} onChange={(e) => setPdfKind(e.target.value as PdfKind)}>
        {PDF_KINDS.map((k) => (
          <option key={k} value={k}>{k}</option>
        ))}
      </select>

      {inputMode === "admin_upload_pdf" && (
        <>
          <label>PDF dosyası</label>
          <input type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files?.[0] ?? null)} />
        </>
      )}

      <button
        className="primary"
        disabled={busy || !examTypeSlug || !institution}
        onClick={run}
      >
        {busy ? "Çalışıyor…" : "Oluştur & import başlat"}
      </button>

      {docId && <p className="muted">Doküman: {docId}</p>}
      {jobId && (
        <p className="muted">
          Job: {jobId} — durum: {status} <button className="ghost" onClick={refresh}>Yenile</button>
        </p>
      )}
      {error && <p className="error">{error}</p>}
    </div>
  );
}
